import { defineStore } from 'pinia';
import { configGetter } from '@/config/configGetter.js';
import { fetchWithBaseParams } from '@/util/fetch.js';
import { useAlertStore } from '@/stores/alert.js';

export const useRatingStore = defineStore('rating', {
  state: () => ({
    rating: undefined,
    requestState: undefined
  }),
  actions: {
    resetRequestState() {
      this.requestState = undefined;
    },
    setRating(rating) {
      this.rating = rating;
    },
    async addRating(payload) {
      const url = `${configGetter().API_URL}/tenant/{tenant}/parcel/{trackingId}/{postcode}/rating`;
      const body = { ...payload.body };

      const alertStore = useAlertStore();

      try {
        alertStore.clearAlert();
        this.requestState = 'LOADING';

        const response = await fetchWithBaseParams(
          url,
          'PUT',
          payload,
          {},
          {
            body: JSON.stringify(body)
          }
        );
        this.rating = response.rating;
        this.requestState = 'SUCCESS';
      } catch (e) {
        const msg = e.body ? { ...e.body } : e.message;
        alertStore.setAlert(msg, 'error', false);
        this.requestState = 'ERROR';
      }
    }
  }
});
